import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items = [] }) => (
    <nav className="flex flex-wrap items-center gap-1 text-xs text-slate-500" aria-label="Breadcrumb" data-testid="breadcrumbs">
        <Link to="/" className="hover:text-brand-blue">Home</Link>
        {items.map((it, i) => (
            <span key={i} className="flex items-center gap-1">
                <ChevronRight size={12} className="text-slate-400" />
                {it.to ? (
                    <Link to={it.to} className="hover:text-brand-blue">{it.label}</Link>
                ) : (
                    <span className="text-slate-800">{it.label}</span>
                )}
            </span>
        ))}
    </nav>
);

export default Breadcrumbs;
